import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import toast from "components/shared/toast/toast";
import { FORM, TRIGGER } from "services/apiEndpoints";
import { privateDelete, privateGet, privatePost, privatePut } from "services/privateRequest";
import { makeQueryString } from "utils/utils";
const initialState = {
    triggerDroppedList: [],
    status: false,
    formData: [],
    triggerList: [],
    trigger: {
        title: "",
        form: "",
        taskBody: {},
        options: [],
        criteria: "Match All",
        alertTo: []
    },
    sendSubmissionTo: {},
    extraSendSubmission:{}
};
export const getTriggerById = createAsyncThunk(
    "trigger/getTriggerById",
    async (payload, { rejectWithValue, dispatch, signal }) => {
        const { id, triggerId } = payload
        try {
            const queryString = makeQueryString(`${FORM}/${id}/trigger/${triggerId}`);

            const { data } = await privateGet(queryString, { signal });
            return {
                trigger: data?.data || {},

            };
        } catch (error) {
            rejectWithValue(error);
            return error;
        }
    })
export const getTriggers = createAsyncThunk(
    "triggers/getTriggers",
    async (id, { rejectWithValue, dispatch, signal }) => {

        try {
            const queryString = makeQueryString(`${FORM}/${id}/trigger`);
            // console.log('queryString', queryString)
            const { data } = await privateGet(queryString, { signal });
            return {
                triggers: data?.data || [],

            };
        } catch (error) {
            rejectWithValue(error);
            return error;
        }


    })

export const deleteTrigger = createAsyncThunk("trigger/deleteTrigger", async ({ id, formId }, { dispatch }) => {
    await privateDelete(TRIGGER, id)
    dispatch(getTriggers(formId))
    toast.success("Approver deleted successfully")
})


export const postTrigger = createAsyncThunk(
    "trigger/postTrigger",
    async (payload, { rejectWithValue, dispatch, signal }) => {

        try {
            const queryString = makeQueryString(`${TRIGGER}`);
            const { data } = await privatePost(queryString, payload, { signal });
            if (data?.success) {
                toast?.success(data?.message)
            }
            return {
                trigger: data?.data?.responses || [],

            };
        } catch (error) {
            rejectWithValue(error);
            return error;
        }


    })

export const updateTrigger = createAsyncThunk(
    "trigger/updateTrigger",
    async (payload, { rejectWithValue, dispatch, signal }) => {
        const { datas, id, triggerId } = payload
        try {
            const queryString = makeQueryString(`${FORM}/${id}/trigger`);
            const { data } = await privatePut(queryString, triggerId, datas, { signal });
            if (data?.success) {
                toast?.success(data?.message)
            }

            return {
                trigger: data?.data?.responses || [],

            };
        } catch (error) {
            rejectWithValue(error);
            return error;
        }


    })

const triggerSlice = createSlice({
    name: "trigger",
    initialState,
    reducers: {
        setDroppedItems: (state, action) => {
            state.triggerDroppedList = action.payload;
        },
        setTriggerPayload: (state, action) => {
            state.trigger = action.payload;

        },
        clearTriggerPayload: (state, action) => {
            state.trigger = {};

        },
        clearSubmissionPayload: (state, action) => {
            state.sendSubmissionTo = {};

        },
        setSendSubmissions: (state, action) => {
            state.sendSubmissionTo = action.payload
        },
        clearExtraSubmissionPayload: (state, action) => {
            state.extraSendSubmission = {};

        },
        setExtraSendSubmissions: (state, action) => {
            state.extraSendSubmission = action.payload
        },

        clearTriggerList: (state, action) => {
            state.triggerDroppedList = [];
        },
        setTriggerFormData: (state, action) => {
            state.formData = action?.payload;
        },
    },
    extraReducers: {
        [getTriggerById.pending]: (state) => {
            state.status = true;
        },
        [getTriggerById.rejected]: (state) => {
            state.status = false;
            state.tasks = [];
        },
        [getTriggerById.fulfilled]: (state, action) => {
            state.trigger = action.payload.trigger
            state.status = false;

        },
        [getTriggers.pending]: (state) => {
            state.status = true;
        },
        [getTriggers.rejected]: (state) => {
            state.status = false;
            state.triggerList = [];
        },
        [getTriggers.fulfilled]: (state, action) => {
            state.status = false;
            state.triggerList = action.payload.triggers
        },
        [postTrigger.pending]: (state) => {
            state.status = true;
        },
        [postTrigger.rejected]: (state) => {
            state.status = false;
            state.tasks = [];
        },
        [postTrigger.fulfilled]: (state, action) => {
            state.status = false;

        },
        [updateTrigger.pending]: (state) => {
            state.status = true;
        },
        [updateTrigger.rejected]: (state) => {
            state.status = false;
            state.tasks = [];
        },
        [updateTrigger.fulfilled]: (state, action) => {
            state.status = false;
        },
        [deleteTrigger.pending]: (state) => {
            state.status = true;
        },
        [deleteTrigger.rejected]: (state) => {
            state.status = false;
        },
        [deleteTrigger.fulfilled]: (state, action) => {
            state.status = false;
        },
    },
});

export default triggerSlice.reducer;
export const { setDroppedItems, clearExtraSubmissionPayload , setExtraSendSubmissions , clearSubmissionPayload, setSendSubmissions, clearTriggerPayload, setTriggerFormData, clearTriggerList, setTriggerPayload } = triggerSlice.actions;
